module.exports = __webpack_public_path__ + "img/individual-prefs.78ab7a4c.svg";